import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER, Injectable } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatBadgeModule, MAT_AUTOCOMPLETE_SCROLL_STRATEGY } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NewCreateRequestModule } from './new-create-request/new-create-request.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DatePipe } from '@angular/common';
import { ToastrModule } from 'ngx-toastr';
import { ReportViewerModule } from 'ngx-ssrs-reportviewer';
import { SignaturePadModule } from 'angular2-signaturepad';
import { ColorPickerModule } from 'ngx-color-picker';
import { NgxSpinnerModule } from "ngx-spinner";
import { OpenOnFocusDirective } from "../open-on-focus.directive";
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { CookieService } from 'ngx-cookie-service';
import { SidebarModule } from 'ng-sidebar';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { AppInitService } from './app-init.service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ActivationComponent } from './activation/activation.component';
import { LoginComponent } from './login/login.component';
import { PatientBannerComponent } from './patient-banner/patient-banner.component';
import { PatientSearchComponent } from './patient-search/patient-search.component';
import { RegistrationFormComponent } from './registration-form/registration-form.component';
import { ToastComponent } from './toast/toast.component';
import { CptMasterComponent } from './AdminModule/AdminConfiguration/cpt-master/cpt-master.component';
import { InsurenceCarrierComponent } from './AdminModule/AdminConfiguration/insurence-carrier/insurence-carrier.component';
import { ManageCatgoriesComponent } from './AdminModule/AdminConfiguration/manage-catgories/manage-catgories.component';
import { PermissionComponent } from './AdminModule/AdminConfiguration/permission/permission.component';
import { RoleComponent } from './AdminModule/AdminConfiguration/role/role.component';
import { AssociateLicensekeyComponent } from './ChildControls/associate-licensekey/associate-licensekey.component';
import { ChooseStatusComponent } from './ChildControls/choose-status/choose-status.component';
import { ClerkRefillComponent } from './ChildControls/clerk-refill/clerk-refill.component';
import { ConfirmationDialogComponent } from './ChildControls/confirmation-dialog/confirmation-dialog.component';
import { CqmsComponent } from './ChildControls/cqms/cqms.component';
import { DenominatorPatientsComponent } from './ChildControls/denominator-patients/denominator-patients.component';
import { DiagonsisDailogComponent } from './ChildControls/diagonsis-dailog/diagonsis-dailog.component';
import { DisplayStaffListComponent } from './ChildControls/display-staff-list/display-staff-list.component';
import { EpcsAddproviderComponent } from './ChildControls/epcs-addprovider/epcs-addprovider.component';
import { EpcsFinalizegrantComponent } from './ChildControls/epcs-finalizegrant/epcs-finalizegrant.component';
import { EncounterDailogComponent } from './ChildControls/encounter-dailog/encounter-dailog.component';
import { InputDialogComponent } from './ChildControls/input-dialog/input-dialog.component';
import { MasterCPTComponent } from './ChildControls/master-cpt/master-cpt.component';
import { MedicationStatusComponent } from './ChildControls/medication-status/medication-status.component';
//import { NewrxAppointmentComponent } from './ChildControls/newrx-appointment/newrx-appointment.component';
import { NumeratorPatientsComponent } from './ChildControls/numerator-patients/numerator-patients.component';
import { PatientCurrentEncountersComponent } from './ChildControls/patient-current-encounters/patient-current-encounters.component';
import { PopupAlertsComponent } from './ChildControls/popup-alerts/popup-alerts.component';
import { ProceduresDialogComponent } from './ChildControls/procedures-dialog/procedures-dialog.component';
import { ProvidersListComponent } from './ChildControls/providers-list/providers-list.component';
import { SearchBoxComponent } from './ChildControls/search-box/search-box.component';
import { ShowFileFromUrlComponent } from './ChildControls/show-file-from-url/show-file-from-url.component';
import { ShowSSRSReportComponent } from './ChildControls/show-ssrsreport/show-ssrsreport.component';
import { TransforUsersComponent } from './ChildControls/transfor-users/transfor-users.component';
import { WarningDialogComponent } from './ChildControls/warning-dialog/warning-dialog.component';
import { VoidPaymentDialogComponent } from './ChildControls/void-payment-dialog/void-payment-dialog.component';
import { PastNotesComponent } from './PatientChart/past-notes/past-notes.component';
import { HttpErrorInterceptor } from './Services/ErrorHandler/http-error.interceptor';
import { AuthGuard } from './Services/authorization/auth.guard';
import { AuthInterceptor } from './Services/authorization/auth.interceptor';
import { ResetPasswordComponent } from './UserManagement/reset-password/reset-password.component';
import { UserComponent } from './UserManagement/user/user.component';
import { AESAlgorithm } from './Utilities/Crypto/AESAlgorithm';
import { NewMessageComponent } from './message-home/new-message/new-message.component';
import { OrderNoteDialogComponent } from './patient-search/order-note-dialog/order-note-dialog.component';
import { AscConsentsComponent } from './AdminModule/AdminConfiguration/asc/asc-consents/asc-consents.component';
import { BillingprovidersComponent } from './AdminModule/AdminConfiguration/billing/billingproviders/billingproviders.component';
import { CmsmasterconfigComponent } from './AdminModule/AdminConfiguration/billing/cmsmasterconfig/cmsmasterconfig.component';
import { CptmasterComponent } from './AdminModule/AdminConfiguration/billing/cptmaster/cptmaster.component';
import { GeneralfeeComponent } from './AdminModule/AdminConfiguration/billing/generalfee/generalfee.component';
import { ManagepayersComponent } from './AdminModule/AdminConfiguration/billing/managepayers/managepayers.component';
import { ProvidermaintenanceComponent } from './AdminModule/AdminConfiguration/billing/providermaintenance/providermaintenance.component';
import { RhPayersComponent } from './AdminModule/AdminConfiguration/billing/rh-payers/rh-payers.component';
import { ClinicprocedureComponent } from './AdminModule/AdminConfiguration/clinic/clinicprocedure/clinicprocedure.component';
import { CqmsFailingPatientsComponent } from './AdminModule/AdminConfiguration/cqms-dashboard/cqms-failing-patients/cqms-failing-patients.component';
import { CqmsQualifingCodesComponent } from './AdminModule/AdminConfiguration/cqms-dashboard/cqms-qualifing-codes/cqms-qualifing-codes.component';
import { EpcsRegistrationComponent } from './AdminModule/AdminConfiguration/epcs-console/epcs-registration/epcs-registration.component';
import { ManageExoStarUserComponent } from './AdminModule/AdminConfiguration/epcs-console/manage-exo-star-user/manage-exo-star-user.component';
import { AppointmentstatusComponent } from './AdminModule/AdminConfiguration/scheduler/appointmentstatus/appointmentstatus.component';
import { DeleteDocumentComponent } from './PatientChart/Document/delete-document/delete-document.component';
import { EditDocumentComponent } from './PatientChart/Document/edit-document/edit-document.component';
import { ProfessionalPayerComponent } from './AdminModule/AdminConfiguration/billing/activepayers/professional-payer/professional-payer.component';
import { ClaimAddressDialogComponent } from './AdminModule/AdminConfiguration/billing/payer-category/claim-address-dialog/claim-address-dialog.component';
import { InsuranceCarriersLookupComponent } from './AdminModule/AdminConfiguration/billing/activepayers/insurance-carriers-lookup/insurance-carriers-lookup.component';
import { PayerClassLookupComponent } from './AdminModule/AdminConfiguration/billing/payer-configuration/payer-class/payer-class-lookup/payer-class-lookup.component';
import { PayerTypeLookupComponent } from './AdminModule/AdminConfiguration/billing/payer-configuration/payer-type/payer-type-lookup/payer-type-lookup.component';
import { PlanNameLookupComponent } from './AdminModule/AdminConfiguration/billing/payer-configuration/plan-name/plan-name-lookup/plan-name-lookup.component';
import { ProvidermaintenanceDialogComponent } from './AdminModule/AdminConfiguration/billing/providermaintenance/providermaintenance-dialog/providermaintenance-dialog.component';
import { AllergensComponent } from './AdminModule/AdminConfiguration/clinic/clinicallergies/allergens/allergens.component';
import { ReactionsComponent } from './AdminModule/AdminConfiguration/clinic/clinicallergies/reactions/reactions.component';
import { OrproceduresComponent } from './PatientChart/OR-Note/encounter-note/orprocedures/orprocedures.component';
import { InitiateRevokeComponent } from './ChildControls/initiate-revoke/initiate-revoke.component';
import { EpcsRevokeDailogComponent } from './ChildControls/epcs-revoke-dailog/epcs-revoke-dailog.component';
import { PlanCopyFromPreviousEncounterComponent } from './ChildControls/plan-copy-from-previous-encounter/plan-copy-from-previous-encounter.component';
import { ConfirmedDialogComponent } from './ChildControls/confirmed-dialog/confirmed-dialog.component';
import { AppConfirmedDialogComponent } from './ChildControls/app-confirmed-dialog/app-confirmed-dialog.component';
import { AppointmentDetailsComponent } from './ChildControls/appointment-details/appointment-details.component';
import { TemplatesFormsComponent } from './Template/templates-forms/templates-forms.component';
import { DateDialogComponent } from './ChildControls/date-dialog/date-dialog.component';
import { AddCategoryComponent } from './ChildControls/add-category/add-category.component';
import { SessionStorageService } from 'angular-web-storage';
import { FluoroscopypreviewReportComponent } from './fluoroscopypreview-report/fluoroscopypreview-report.component';
import { ImagePdfConvertComponent } from './PatientChart/OR-Note/encounter-note/orfluoroscope-images/image-pdf-convert/image-pdf-convert.component';
import { CustomSlotComponent } from './ChildControls/custom-slot/custom-slot.component';
import { NextAppointmentComponent } from './ChildControls/next-appointment/next-appointment.component';
import { CptDiagnosisListComponent } from './ChildControls/cpt-diagnosis-list/cpt-diagnosis-list.component';
import { ManageicdDialogComponent } from './ChildControls/manageicd-dialog/manageicd-dialog.component';
import { FilterPipe } from './filter-pipe.pipe';
import { SuneditortestComponent } from './suneditortest/suneditortest.component';
import { OrdersSelectDXComponent } from './ChildControls/orders-selectDx/orders-selectDx.component';
import { VideocallingDivComponent } from './videocalling-div/videocalling-div.component';
import { Overlay, CloseScrollStrategy } from '@angular/cdk/overlay';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { AppAppendCommentsComponent } from './ChildControls/app-append-comments/app-append-comments.component';
import { TabDirective } from './tab-directive';
import { OwlDateTimeModule, OwlNativeDateTimeModule, OWL_DATE_TIME_LOCALE } from 'ng-pick-datetime';
import { CalTemplateComponent } from './PatientChart/cal-templates/cal-template/cal-template.component';
import { AssignTemplateComponent } from './PatientChart/cal-templates/assign-template/assign-template.component';
import { SharedHeaderModule } from './SharedHeaders.module';
import { CalTemplatesModule } from './PatientChart/cal-templates/cal-templates.module';
//import { PartialBlockComponent } from './partial-block/partial-block.component';
import { FacilityProviderComponent } from './ChildControls/facility-provider/facility-provider.component';
import { PrintPatientUserDetailsComponent } from './ChildControls/print-patient-user-details/print-patient-user-details.component';
import { DialerpadDivComponent } from 'src/app/dialerpad-div/dialerpad-div.component'
// import { IntstaffChatComponent } from './intstaff-chat/intstaff-chat.component';
import { SurescriptsClinicalDirectMessageComponent } from './ChildControls/surescripts-clinical-direct-message/surescripts-clinical-direct-message.component';
import { DirectMessagePreviewFileComponent } from './ChildControls/direct-message-preview-file/direct-message-preview-file.component';
import { SearchPatientDMPopupComponent } from './search-patient-dmpopup/search-patient-dmpopup.component';
import { TaskmessagesnewtaskComponent } from './message/taskmessagesnewtask/taskmessagesnewtask.component';
import { GroupNameDialogComponent } from './group-name-dialog/group-name-dialog.component';

import { TaskmessagesviewComponent } from './message/taskmessagesview/taskmessagesview.component';
import { MessagesReplayForwardComponent } from './message/messages-replay-forward/messages-replay-forward.component';
import { SharedComponent } from './shared/shared.component';
import { AutoclaimComponent } from './AdminModule/AdminConfiguration/billing/autoclaim/autoclaim.component';
import { FinancialComponent } from './AdminModule/AdminConfiguration/billing/financial/financial.component';
import { ManageNdcComponent } from './AdminModule/AdminConfiguration/billing/manage-ndc/manage-ndc.component';
import { PayersclaimtypeComponent } from './AdminModule/AdminConfiguration/billing/payersclaimtype/payersclaimtype.component';
import { Ub04masterconfigComponent } from './AdminModule/AdminConfiguration/billing/ub04masterconfig/ub04masterconfig.component';
import { ClinicallergiesComponent } from './AdminModule/AdminConfiguration/clinic/clinicallergies/clinicallergies.component';
import { ClinicdxComponent } from './AdminModule/AdminConfiguration/clinic/clinicdx/clinicdx.component';
import { AutoLogoffComponent } from './ChildControls/AutoLogoff';
import { OrProceduresComponent } from './ChildControls/or-procedures/or-procedures.component';
import { CalendarComponent } from './Template/calendar/calendar.component';
import { ConfigureComponent } from './admin/configure/configure.component';
import { RefillsComponent } from './message/message-home/refills/refills.component';
import { AscComponent } from './AdminModule/AdminConfiguration/asc/asc.component';
import { OrrecordComponent } from './AdminModule/AdminConfiguration/asc/orrecord/orrecord.component';
import { IvsiteeComponent } from './AdminModule/AdminConfiguration/asc/orrecord/ivsitee/ivsitee.component';
import { OrrecordSizeComponent } from './AdminModule/AdminConfiguration/asc/orrecord/orrecord-size/orrecord-size.component';
import { OrrecordFluidsComponent } from './AdminModule/AdminConfiguration/asc/orrecord/orrecord-fluids/orrecord-fluids.component';
import { OrrecordPositionsComponent } from './AdminModule/AdminConfiguration/asc/orrecord/orrecord-positions/orrecord-positions.component';
import { OrrecordPrepComponent } from './AdminModule/AdminConfiguration/asc/orrecord/orrecord-prep/orrecord-prep.component';
import { OrrecordContrastComponent } from './AdminModule/AdminConfiguration/asc/orrecord/orrecord-contrast/orrecord-contrast.component';
import { OrrecordSkinprepComponent } from './AdminModule/AdminConfiguration/asc/orrecord/orrecord-skinprep/orrecord-skinprep.component';
import { OrrecordVolumeComponent } from './AdminModule/AdminConfiguration/asc/orrecord/orrecord-volume/orrecord-volume.component';
import { OrrecordAnesthesiaComponent } from './AdminModule/AdminConfiguration/asc/orrecord/orrecord-anesthesia/orrecord-anesthesia.component';
import { OrrecordAssistantComponent } from './AdminModule/AdminConfiguration/asc/orrecord/orrecord-assistant/orrecord-assistant.component';
import { OrrecordRadiographerComponent } from './AdminModule/AdminConfiguration/asc/orrecord/orrecord-radiographer/orrecord-radiographer.component';
import { OrrecordRoomComponent } from './AdminModule/AdminConfiguration/asc/orrecord/orrecord-room/orrecord-room.component';
import { AscpostSurgicalComponent } from './AdminModule/AdminConfiguration/asc/ascpost-surgical/ascpost-surgical.component';
import { AnesthesiologistComponent } from './AdminModule/AdminConfiguration/asc/ascpost-surgical/anesthesiologist/anesthesiologist.component';
import { AnesthelistComponent } from './AdminModule/AdminConfiguration/asc/ascpost-surgical/anesthelist/anesthelist.component';
import { SiteComponent } from './AdminModule/AdminConfiguration/asc/ascpost-surgical/site/site.component';
import { AssessmentComponent } from './AdminModule/AdminConfiguration/asc/assessment/assessment.component';
import { IvfluidsComponent } from './AdminModule/AdminConfiguration/asc/assessment/ivfluids/ivfluids.component';
import { IVsiteComponent } from './AdminModule/AdminConfiguration/asc/assessment/ivsite/ivsite.component';
import { SizeComponent } from './AdminModule/AdminConfiguration/asc/assessment/size/size.component';
import { StartedByComponent } from './AdminModule/AdminConfiguration/asc/assessment/started-by/started-by.component';
import { PreviewFileOrImageComponent } from './preview-file-or-image/preview-file-or-image.component';
import { CCDAModule } from './CCDA/ccda.module';
import { NewSearchsnomedmasterComponent } from './ChildControls/new-searchsnomedmaster/new-searchsnomedmaster.component';
import { EmergencyUserAcessComponent } from './ChildControls/emergencyUserAccess';
import { LoginModelComponent } from './ChildControls/login-model/login-model.component';
import { CCDASearchPatientComponent } from 'src/app/ChildControls/ccdasearch-patient/ccdasearch-patient.component';
import { ViewAmmendmentsNotesComponent } from './patient-portal/patient-ammendments-note/view-ammendments-notes/view-ammendments-notes.component';
import { ReconciliationComponent } from './ChildControls/reconciliation/reconciliation.component';
import { ONCCMeasureComponent } from './onccmeasure/onccmeasure.component';
import { OnccMUComponent } from './oncc-mu/oncc-mu.component';
import { OnccConfigurationComponent } from './oncc-configuration/oncc-configuration.component';
import { PatientSecureMessagesComponent } from './message/patient-secure-messages/patient-secure-messages.component';
import { MasterLabOrdersComponent } from './ChildControls/master-lab-orders/master-lab-orders.component';
import { DxsnomedmasterComponent } from './ChildControls/dxsnomedmaster/dxsnomedmaster.component';
//import { InternetSpeedDetectorComponent } from './ChildControls/InternetSpeedDetector';
//'./dialerpad-div/dialerpad-div.component';
import { InterventionOutcomeComponent } from './ChildControls/intervention-outcome/intervention-outcome.component';
import { AutoMeasurePatientInfoComponent } from './oncc-mu/auto-measure-patient-info/auto-measure-patient-info.component';
import { InpatientComponent } from './ChildControls/inpatient/inpatient.component';
import { CqmsMergePatientComponent } from './ChildControls/cqms-merge-patient/cqms-merge-patient.component';
import { CommentLogsComponent } from './ChildControls/comment-logs/comment-logs.component';
import { HxTobaccoHistoryComponent } from './ChildControls/hx-tobacco-history/hx-tobacco-history.component';
import { AutoGenerateContentComponent } from './ChildControls/auto-generate-content/auto-generate-content.component';
import { AddressHistoryComponent } from './PatientChart/Demographics/patient-demographics/addresshistory/address_history.component';
import { configuration } from 'src/environments/environment';
import { PatientConfirmDialogComponent } from './ChildControls/patient-confirm-dialog/patient-confirm-dialog.component';
import { PatientProceduresComponent } from './ChildControls/patient-procedures/patient-procedures.component';
// import { CqmsmodelwidgetComponent } from './cqmsmodelwidget/cqmsmodelwidget.component';
import { ProcedureLogsComponent } from './ChildControls/procedure-logs/procedure-logs.component';
import { SingnaturePadPopUpComponent } from './singnature-pad-pop-up/singnature-pad-pop-up.component';
import { HcpcsCodesComponent } from './ChildControls/hcpcs-codes/hcpcs-codes.component';
import { ApiResponseInterceptor } from './Sharedservice/api-response.interceptor';
import { FollowupNewAppointmentComponent } from './ChildControls/followup-new-appointment/followup-new-appointment.component';
import { FollowupSurgeryReferralComponent } from './ChildControls/followup-surgery-referral/followup-surgery-referral.component';

@Injectable()

export class NoCacheHeadersInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler) {
    if (req.url.indexOf(configuration.ClientIpAdressURL) > -1) {
      return next.handle(req.clone());
    } const authReq = req.clone({
      setHeaders: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache'
      }
    });
    return next.handle(authReq);
  }
}

// export class NoCacheHeadersInterceptor implements HttpInterceptor {
//   intercept(req: HttpRequest<any>, next: HttpHandler) {
//     const authReq = req.clone({
//       setHeaders: {
//         'Cache-Control': 'no-cache',
//         Pragma: 'no-cache'
//       }
//     });
//     return next.handle(authReq);
//   }
// }


export function init_app(appLoadService: AppInitService) {
  return () => appLoadService.init();
}

export function scrollFactory(overlay: Overlay): () => CloseScrollStrategy {
  return () => overlay.scrollStrategies.close();
}

const maskConfigFunction: () => Partial<IConfig> = () => {
  return {
    validation: false,
  };
};

export const MY_CUSTOM_FORMATS = {
  parseInput: 'MM/DD/YYYY',
  fullPickerInput: 'MM/DD/YYYY hh:mm a',
  datePickerInput: 'MM/DD/YYYY',
  timePickerInput: 'hh:mm a',
  monthYearLabel: 'MMM-YYYY',
  dateA11yLabel: 'LL',
  monthYearA11yLabel: 'MMMM-YYYY'
};

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ToastComponent,
    PatientSearchComponent,
    UserComponent,
    ResetPasswordComponent,
    PastNotesComponent,
    InputDialogComponent,
    PatientCurrentEncountersComponent,
    DisplayStaffListComponent,
    EditDocumentComponent,
    ConfirmationDialogComponent,
    ShowFileFromUrlComponent,
    ManageCatgoriesComponent,
    OrderNoteDialogComponent,
    AppointmentstatusComponent,
    PatientBannerComponent,
    AllergensComponent,
    ReactionsComponent,
    ClinicprocedureComponent,
    BillingprovidersComponent,
    GeneralfeeComponent,
    CmsmasterconfigComponent,
    RhPayersComponent,
    CptmasterComponent,
    ManagepayersComponent,
    ProvidermaintenanceComponent,
    ProvidermaintenanceDialogComponent,
    OrproceduresComponent,
    WarningDialogComponent,
    VoidPaymentDialogComponent,
    ProceduresDialogComponent,
    InsurenceCarrierComponent,
    ProfessionalPayerComponent,
    ClaimAddressDialogComponent,
    InsuranceCarriersLookupComponent,
    PayerClassLookupComponent,
    PayerTypeLookupComponent,
    PlanNameLookupComponent,
    RegistrationFormComponent,
    ActivationComponent,
    AscConsentsComponent,
    PopupAlertsComponent,
    NewMessageComponent,
    CptMasterComponent,
    RoleComponent,
    PermissionComponent,
    SearchBoxComponent,
    // NewrxAppointmentComponent,
    ChooseStatusComponent,
    MedicationStatusComponent,
    ClerkRefillComponent,
    TransforUsersComponent,
    CqmsFailingPatientsComponent,
    CqmsQualifingCodesComponent,
    AssociateLicensekeyComponent,
    EpcsAddproviderComponent,
    EpcsRegistrationComponent,
    MasterCPTComponent,
    ProvidersListComponent,
    ManageExoStarUserComponent,
    DenominatorPatientsComponent,
    NumeratorPatientsComponent,
    EpcsFinalizegrantComponent,
    EncounterDailogComponent,
    DiagonsisDailogComponent,
    InitiateRevokeComponent,
    EpcsRevokeDailogComponent,
    PlanCopyFromPreviousEncounterComponent,
    ConfirmedDialogComponent,
    AppConfirmedDialogComponent,
    AppointmentDetailsComponent,
    TemplatesFormsComponent,
    DateDialogComponent,
    AddCategoryComponent,
    FluoroscopypreviewReportComponent,
    ImagePdfConvertComponent,
    CustomSlotComponent,
    NextAppointmentComponent,
    CptDiagnosisListComponent,
    ManageicdDialogComponent,
    FilterPipe,
    SuneditortestComponent,
    VideocallingDivComponent,
    DialerpadDivComponent,
    AppAppendCommentsComponent,
    OpenOnFocusDirective,
    TabDirective,
    CalTemplateComponent,
    AssignTemplateComponent,
    OrdersSelectDXComponent,
    // PartialBlockComponent
    FacilityProviderComponent,
    PrintPatientUserDetailsComponent,
    //  IntstaffChatComponent,
    SurescriptsClinicalDirectMessageComponent,
    DirectMessagePreviewFileComponent,
    SearchPatientDMPopupComponent,
    GroupNameDialogComponent,
    TaskmessagesnewtaskComponent,
    TaskmessagesviewComponent,
    MessagesReplayForwardComponent,
    SharedComponent,
    NewSearchsnomedmasterComponent,
    // InternetSpeedDetectorComponent
    EmergencyUserAcessComponent,
    AutoLogoffComponent,
    LoginModelComponent,
    CCDASearchPatientComponent,
    ReconciliationComponent,
    MasterLabOrdersComponent,
    ONCCMeasureComponent,
    OnccMUComponent,
    OnccConfigurationComponent,
    PatientSecureMessagesComponent,
    DxsnomedmasterComponent,
    InterventionOutcomeComponent,
    AutoMeasurePatientInfoComponent,
    InpatientComponent,
    CqmsMergePatientComponent,
    CommentLogsComponent,
    HxTobaccoHistoryComponent,
    AutoGenerateContentComponent,
    AddressHistoryComponent,
    ProcedureLogsComponent,
    SingnaturePadPopUpComponent,
    HcpcsCodesComponent,
    FollowupNewAppointmentComponent,
    FollowupSurgeryReferralComponent,
    AutoclaimComponent,
    FinancialComponent,
    ManageNdcComponent,
    PayersclaimtypeComponent,
    Ub04masterconfigComponent,
    ClinicallergiesComponent,
    ClinicdxComponent,
    OrProceduresComponent,
    CalendarComponent,
    ConfigureComponent,
    RefillsComponent,
    AscComponent,
    OrrecordComponent,
    IvsiteeComponent,
    OrrecordSizeComponent,
    OrrecordFluidsComponent,
    OrrecordPositionsComponent,
    OrrecordPrepComponent,
    OrrecordContrastComponent,
    OrrecordSkinprepComponent,
    OrrecordVolumeComponent,
    OrrecordAnesthesiaComponent,
    OrrecordAssistantComponent,
    OrrecordRadiographerComponent,
    OrrecordRoomComponent,
    AscpostSurgicalComponent,
    AnesthesiologistComponent,
    AnesthelistComponent,
    SiteComponent,
    AssessmentComponent,
    IvfluidsComponent,
    IVsiteComponent,
    SizeComponent,
    StartedByComponent,
    PreviewFileOrImageComponent
    // CqmsmodelwidgetComponent,
  ],
  imports: [
    SidebarModule.forRoot(),
    BrowserModule,
    AppRoutingModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    BrowserAnimationsModule,
    FormsModule, ReactiveFormsModule,
    NewCreateRequestModule,
    HttpClientModule,
    MatBadgeModule,
    ToastrModule.forRoot({
      maxOpened: 1,
      preventDuplicates: true,
      positionClass: 'toast-top-center'

    }),

    DragDropModule,
    ReportViewerModule,
    SignaturePadModule,
    MatDialogModule,
    ColorPickerModule,
    NgxMaskModule.forRoot(),
    NgxSpinnerModule,
    NgxMaterialTimepickerModule,
    ScrollingModule,
    SharedHeaderModule,
    CalTemplatesModule,
    CCDAModule,
    NewCreateRequestModule,

  ],
  providers: [
    AuthGuard
    , DatePipe
    , {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true
    },
    { provide: MAT_AUTOCOMPLETE_SCROLL_STRATEGY, useFactory: scrollFactory, deps: [Overlay] },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NoCacheHeadersInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    { provide: HTTP_INTERCEPTORS, useClass: ApiResponseInterceptor, multi: true },
    {
      provide: MatDialogRef,
      useValue: {}
    },
    {
      provide: MAT_DIALOG_DATA,
      useValue: {}
    },
    AESAlgorithm,
    // ASCMaster,
    CookieService,
    AppInitService,
    {
      provide: APP_INITIALIZER,
      useFactory: init_app,
      deps: [AppInitService],
      multi: true
    },
    CqmsComponent,
    SessionStorageService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NoCacheHeadersInterceptor,
      multi: true
    },
    { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
    { provide: OWL_DATE_TIME_LOCALE, useValue: MY_CUSTOM_FORMATS },
  ],
  bootstrap: [AppComponent],
  // schemas: [CUSTOM_ELEMENTS_SCHEMA],
  entryComponents: [
    //PartialBlockComponent,
    SearchPatientDMPopupComponent,
    ConfirmationDialogComponent,
    ShowSSRSReportComponent,
    InputDialogComponent,
    WarningDialogComponent,
    VoidPaymentDialogComponent,
    PatientCurrentEncountersComponent,
    OrproceduresComponent,
    MedicationStatusComponent,
    ChooseStatusComponent,
    ProceduresDialogComponent,
    NumeratorPatientsComponent,
    InitiateRevokeComponent,
    CustomSlotComponent,
    PopupAlertsComponent,
    AssociateLicensekeyComponent,
    EncounterDailogComponent,
    ConfirmedDialogComponent,
    EpcsFinalizegrantComponent,
    DateDialogComponent,
    DeleteDocumentComponent,
    AppointmentDetailsComponent,
    ProvidermaintenanceDialogComponent,
    AppConfirmedDialogComponent,
    ShowFileFromUrlComponent,
    CptDiagnosisListComponent,
    PatientSearchComponent,
    EpcsAddproviderComponent,
    DenominatorPatientsComponent,
    NextAppointmentComponent,
    ManageCatgoriesComponent,
    ProvidersListComponent,
    TransforUsersComponent,
    AppAppendCommentsComponent,
    ClerkRefillComponent,
    OrderNoteDialogComponent,
    EpcsRevokeDailogComponent,
    DisplayStaffListComponent,
    SearchBoxComponent,
    DiagonsisDailogComponent,
    EditDocumentComponent,
    OrdersSelectDXComponent,
    AddCategoryComponent,
    ManageicdDialogComponent,
    MasterCPTComponent,
    ProfessionalPayerComponent,
    ClaimAddressDialogComponent,
    InsuranceCarriersLookupComponent,
    PayerClassLookupComponent,
    PayerTypeLookupComponent,
    PlanNameLookupComponent,
    PlanCopyFromPreviousEncounterComponent,
    FacilityProviderComponent,
    PrintPatientUserDetailsComponent,
    SurescriptsClinicalDirectMessageComponent,
    DirectMessagePreviewFileComponent,
    GroupNameDialogComponent
    , TaskmessagesnewtaskComponent
    , TaskmessagesviewComponent
    , MessagesReplayForwardComponent
    , NewSearchsnomedmasterComponent
    , LoginModelComponent,
    CCDASearchPatientComponent
    , ViewAmmendmentsNotesComponent
    , ReconciliationComponent,
    MasterLabOrdersComponent,
    PatientSecureMessagesComponent,
    DxsnomedmasterComponent,
    InterventionOutcomeComponent,
    AutoMeasurePatientInfoComponent,
    InpatientComponent,
    CqmsMergePatientComponent,
    CommentLogsComponent,
    HxTobaccoHistoryComponent,
    AutoGenerateContentComponent,
    AddressHistoryComponent,
    PatientConfirmDialogComponent,
    PatientProceduresComponent,
    ProcedureLogsComponent,
    HcpcsCodesComponent,
    FollowupNewAppointmentComponent,
    FollowupSurgeryReferralComponent
  ]
})
export class AppModule { }
